import { Container } from "@mui/material";
import ScrollToTop from "@ui/atoms/ScrollToTop/ScrollToTop";
import { ReactNode } from "react";

export interface Props {
  children: ReactNode;
}

export const NoMenuLayout = ({ children }: Props) => {
  return (
    <>
      <ScrollToTop />
      <Container
        maxWidth="xl"
        disableGutters
        sx={{ height: "100%" }}
        data-test-id="main-page-layout"
      >
        {children}
      </Container>
    </>
  );
};
